import React from 'react'

import { ConvoIconButton } from 'conversations/components/TideWrappers'

import styles from './styles.module.css'

interface Props {
  setModalOpen: () => void
}

const CreateNewSection = ({ setModalOpen }: Props): JSX.Element => (
  <div className={styles.sectionHeader} onClick={setModalOpen}>
    <div>Create new section</div>
    <ConvoIconButton icon="plus" className={styles.sectionHeaderIcon} size="small" />
  </div>
)

export default CreateNewSection
